import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, inject, signal, computed, input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {
  getTrackingType, getTrackingTypeError,
  ITrackingTypeState, ResetTrackingTypeState, TrackingType, UpdateTrackingTypeStatus
} from '@app/stores';
import { select, Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SbTableComponent } from '@app/_components/unified/sb-table/sb-table.component';
import { SbTableCellDirective } from '@app/_components/unified/sb-table/sb-table.directives';
import { SbTableColumn, SbTableOptions } from '@app/_components/unified/sb-table/sb-table.types';
import moment from 'moment-timezone';

@Component({
  selector: 'app-tracking-accuracy-modal',
  templateUrl: './tracking-accuracy-modal.component.html',
  styleUrls: ['./tracking-accuracy-modal.component.scss'],
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SbTableComponent, SbTableCellDirective]
})
export class TrackingAccuracyModalComponent implements OnInit, OnDestroy {
  private toastr = inject(ToastrService);
  private trackingTypeStore = inject<Store<ITrackingTypeState>>(Store);
  modal = inject(NgbActiveModal);

  readonly projectId = input(undefined);
  unsubscriber = new Subject();
  readonly trackingType = signal<any[]>([]);
  /** The tracking types this project has conversions from: the rows the table shows. */
  readonly rows = computed(() => this.trackingType().filter((type) => type.project_total && type.project_total > 0));
  _moment = moment;
  readonly tableColumns: SbTableColumn[] = [
    {id: 'checked', header: '#'},
    {id: 'name', header: 'Name'},
    {id: 'accuracy', header: 'Accuracy(%)'},
    {id: 'project_total', header: 'Total'},
  ];
  // The old table never started its DataTable: a plain list, most conversions first, nothing to
  // search, page or sort.
  readonly tableOptions: SbTableOptions = {
    selectable: false,
    searching: false,
    paging: false,
    ordering: false,
    emptyMessage: 'No data found',
    tableId: 'dt-table',
  };

  constructor() {
    this.trackingTypeStore.dispatch(ResetTrackingTypeState({params: {error: '', success: ''}}));
  }

  ngOnInit(): void {
    this.trackingTypeStore.dispatch(TrackingType({projectId: this.projectId()}));
    this.subscribeStore();
  }

  subscribeStore(): void {
    this.trackingTypeStore.pipe(select(getTrackingTypeError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastr.error(error, 'Error');
        }
      });

    this.trackingTypeStore.pipe(select(getTrackingType))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((trackingType: any) => {
        if (trackingType) {
          const sortedTrackingType = [...trackingType];
          this.trackingType.set(sortedTrackingType.sort((a, b) => b.project_total - a.project_total));
        }
      });
  }

  toggleChecked(type: any) {
    this.trackingType.update((types) => types.map(t =>
      t.id === type.id ? { ...t, checked: !t.checked } : t
    ));
  }

  ngOnDestroy() {}

  saveTrackingAccurancy() {
    this.trackingTypeStore.dispatch(UpdateTrackingTypeStatus({ projectId: this.projectId(), trackingType: this.trackingType() }));
    this.modal.close(true);
  }

}
